import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import type { SerializedError } from '@reduxjs/toolkit';

export const isCreditsFeatureUnavailable = (error: FetchBaseQueryError | SerializedError | undefined): boolean =>
  Boolean(error && 'status' in error && error.status === 503);
